import { Divider, Stack, Typography } from '@mui/material';
import React, { ReactElement, useCallback } from 'react';
import { useTheme } from 'styled-components';
import InfoDrawer from '../../abstract/InfoDrawer';
import InfoRow from '../../components/InfoRow';
import { formatDate, getAge } from '../../utils';
import { GetCycleResponseItem } from './types';

const PatientInfoDrawer: React.FC<{ cycle: GetCycleResponseItem, open: boolean, onClose: () => void }> = ({ cycle, open, onClose }) => {

    const theme = useTheme();

    const patientInfoRow = useCallback((label: string, value: string | number | ReactElement, date?: Date) => (
        <Stack gap={1}>
            <InfoRow valueFontWeight='normal' labelWidth={270} label={label} value={value} date={date} />
            <Divider />
        </Stack>
    ), []);

    return (
        <InfoDrawer
            width={600}
            cycle={cycle}
            open={open}
            onClose={onClose}
        >
            <Stack gap={2}>
                <Stack gap={theme.spacing(2)}>
                    <Typography fontWeight={"bold"} variant="report.title">
                        Patient Background
                    </Typography>
                    <Stack gap={2}>
                        {patientInfoRow('Name', cycle.patient)}
                        {patientInfoRow('Age', getAge(new Date(cycle.birth)))}
                        {patientInfoRow('Height', `${cycle.height} cm`)}
                        {patientInfoRow('Weight', `${cycle.weight} kg`)}
                        {/* {patientInfoRow('Ethnicity', cycle.ethnicity.join(', '))} */}
                    </Stack>
                </Stack>
            </Stack>
            <Stack gap={2}>
                <Typography fontWeight={"bold"} variant="report.title">
                    Medical History
                </Typography>
                <Stack gap={2}>
                    {patientInfoRow('Primary infertility diagnosis', `Ovulatory disfunction, Male factor`)}
                    {patientInfoRow('Relevant medical conditions', `PCOS, Autoimmune diseases`)}
                    {patientInfoRow('Current medication', `Levothyroxine 75 mcg daily, Metformin 500 mg twice daily`)}
                </Stack>
            </Stack>
            <Stack gap={2} sx={{ marginTop: theme.spacing(6) }}>
                <Typography fontWeight={"bold"} variant="report.title">
                    IVF History
                </Typography>
                <Typography fontWeight={"bold"} variant="report.title">
                    Cycle 1
                </Typography>
                <Stack gap={2}>
                    {patientInfoRow('Cycle date', formatDate(new Date(cycle.created)))}
                    {patientInfoRow('Stimulation protocol used', `GnRH Antagonist`)}
                    {patientInfoRow('Total Gonadotropin dose used', `150 IU`)}
                    {patientInfoRow('Oocytes retrieved', `5`)}
                    {patientInfoRow('Mature oocytes', `4`)}
                    {patientInfoRow('Fertilized oocytes', `12`)}
                    {patientInfoRow('Outcome', `Positive pregnancy`)}
                    {patientInfoRow('Any complications', `None`)}

                </Stack>

            </Stack>
        </InfoDrawer>
    );
};

export default PatientInfoDrawer;
